import React from 'react';
import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/disk.module.scss';
import Image from 'next/image';

export default function Disk () {
  const router = useRouter();
  const { t } = useTranslation('disk');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
        <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
        
        <div className='service_disk_section'>
          <InfoSection title='Disk' description='diskDescription' getAccessLink='https://disk.icdc.io/' documentationLink='https://help.icdc.io/disk/' lang={router.locale} />

          <section className={styles.main}>
            <div className={styles.top}>
              <div>
                <h2>{t('cloud_disk.title')}</h2>
                <p>{t('cloud_disk.description')}</p>
                <br />
                <br />
              <h3>{t('cloud_disk.for_humans.title')}</h3>
                <p>{t('cloud_disk.for_humans.description')}</p>
                <br />
              <h3>{t('cloud_disk.for_projects.title')}</h3>
                <p>{t('cloud_disk.for_projects.description')}</p>
              </div>
            <Image src='/disk.webp' alt='Disk interface' width={841} height={422} unoptimized loading='lazy' />
            </div>
            <div className={'flex col ' + styles.bottom}>
              <h2>{t('main_features.title')}</h2>
              <div>
                {
                  new Array(8).fill('').map((_, index) => <p key={index} dangerouslySetInnerHTML={
                    {__html: t(`main_features.item${index + 1}`, { interpolation: { escapeValue: false }})}
                  } />)
                }
              </div>
            </div>
          </section>

          {/* <DiskCapabilities /> */}
        </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['disk', 'common']),
  },
});
